import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { Box } from '@apia/theme';
import { Ellipsis } from './Ellipsis';
import { StreamMessage } from '../StreamMessage';
import { MessageBlocks, TTextStreamBlock } from './MessageBlocks';
import { IconButton, MDRenderer } from '@apia/components';

export const MessageBody = observer(
  ({
    onRate,
    store,
  }: {
    onRate?: (target: HTMLElement, how: 'up' | 'down') => Promise<boolean>;
    store: StreamMessage;
  }) => {
    const [thumb, setThumb] = useState<'up' | 'down' | undefined>(undefined);
    const hasText =
      (store.blocks.find((x) => x.blockType === 'text')?.str ?? '').length > 0;
    return (
      <Box className="sem_search__system_message">
        <>
          <Box className="message__body markdown">
            {
              <MessageBlocks
                streamParts={[
                  ...store.blocks.filter((x) => x.blockType === 'describer'),
                  ...(hasText && store.messageHeader
                    ? [
                        {
                          blockType: 'text',
                          str: store.messageHeader,
                        } as TTextStreamBlock,
                      ]
                    : []),
                  ...store.blocks.filter((x) => x.blockType === 'text'),
                ]}
              ></MessageBlocks>
            }
          </Box>
          {onRate && hasText ? (
            <Box className="sem_search__thumbs">
              <IconButton
                variant="icon-only"
                icon="ThumbsUp"
                className={
                  thumb === 'up'
                    ? 'selected'
                    : thumb === 'down'
                      ? 'unselected'
                      : 'no_feedback'
                }
                onClick={(ev) => {
                  if (!thumb) {
                    onRate(ev.target as HTMLElement, 'up').then((res) => {
                      if (res) {
                        setThumb('up');
                      }
                    });
                  }
                }}
              />
              <IconButton
                variant="icon-only"
                icon="ThumbsDown"
                className={
                  thumb === 'down'
                    ? 'selected'
                    : thumb === 'up'
                      ? 'unselected'
                      : 'no_feedback'
                }
                onClick={(ev) => {
                  if (!thumb) {
                    onRate(ev.target as HTMLElement, 'down').then((res) => {
                      if (res) {
                        setThumb('down');
                      }
                    });
                  }
                }}
              />
            </Box>
          ) : (
            <></>
          )}
        </>
        {!hasText && <Ellipsis />}
        {store.messageFooter && store.finished && (
          <Box className="message__body markdown">
            <MDRenderer str={store.messageFooter}></MDRenderer>
          </Box>
        )}
      </Box>
    );
  },
);
